import { render, staticRenderFns } from "./EmailAttachment.vue?vue&type=template&id=d523fe1c&scoped=true&"
import script from "./EmailAttachment.vue?vue&type=script&lang=js&"
export * from "./EmailAttachment.vue?vue&type=script&lang=js&"
import style0 from "./EmailAttachment.vue?vue&type=style&index=0&id=d523fe1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d523fe1c",
  null
  
)

export default component.exports